import { render, staticRenderFns } from "./BannerXApp.vue?vue&type=template&id=7edb4964"
import script from "./BannerXApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./BannerXApp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BannerXApp.vue?vue&type=style&index=0&id=7edb4964&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports